import type { FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'
import { OrderMethod } from '@/libs/helpers/utils'
import { SvgIcon, Text } from '@/tbui'

const StyledIcon = styled(SvgIcon)`
  margin: 0 auto;
  ${(props) =>
    props.theme.mixin.fluidRange(
      {
        prop: 'fontSize',
        fromSize: '34px',
        toSize: '90px',
      },
      {
        prop: 'marginBottom',
        fromSize: '30px',
        toSize: '40px',
      }
    )};
`

const StyledTitle = styled(Text)`
  line-height: 1.42;
  ${(props) =>
    props.theme.mixin.fluidRange({
      prop: 'fontSize',
      fromSize: '20px',
      toSize: '36px',
    })};
`

const StyledSubtitle = styled(Text)`
  line-height: 1.42;
  @media (min-width: ${(props) => props.theme.breakpoints.SM}) {
    max-width: 50%;
  }
  ${(props) =>
    props.theme.mixin.fluidRange(
      {
        prop: 'fontSize',
        fromSize: '14px',
        toSize: '24px',
      },
      {
        prop: 'marginBottom',
        fromSize: '20px',
        toSize: '30px',
      }
    )};
`

interface OrderPlacedMessageProps {
  orderMethod: OrderMethod
}

const OrderPlacedMessage: FunctionComponent<OrderPlacedMessageProps> = ({ orderMethod }) => {
  const { t } = useTranslation()

  const translationContext = orderMethod.toLowerCase()

  return (
    <>
      <StyledIcon name="check_circle" color="SUCCESS" />
      <StyledTitle type="H1" align="center">
        {t('order.success.title')}
      </StyledTitle>
      <StyledSubtitle align="center" bold={false} m="30px auto" type="H2">
        {t('order.success.subtitle', {
          context: translationContext,
        })}
      </StyledSubtitle>
    </>
  )
}

export default OrderPlacedMessage
